import React from "react";
import logo from "../images/mb-m-500-white.png";

export default function SectionHeader({ id, heading, description }) {
  return (
    <section id={id} className="my-8 lg:my-10 bg-primary-animated text-gray-100 py-20 md:py-24 px-10">
      <div className="max-w-screen-lg mx-auto flex flex-col items-center text-center">
        <img src={logo} alt="" className="w-8 mb-4" />
        <h2 className="text-4xl font-black">{heading}</h2>
        {description && <p className="mt-4 text-gray-100 max-w-2xl">{description}</p>}
      </div>
    </section>
  );
}
